import React, { useState, useEffect } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import ContentCard from "../../common/template/contentCard";
import ContentCardBody from "../../common/template/contentCardBody";
import { getListaGraficoCustoMensalUsinaAluguel, getListaEconomiaUsinaAluguelRemotasMensal } from "../analiseActions";
import { montarGraficoColumn } from "../../common/graficos/montarGraficoColumn.js";
import { montarGraficoGroupStackedColumn } from "../../common/graficos/montarGraficoGroupStackedColumn.js";
import * as am4core from "@amcharts/amcharts4/core";
import { adicionarPontosMilhar } from "../../utils/adicionarPontosMilhar.js";
import Table from "../../common/table/table";
import THead from "../../common/table/tHead";
import Tr from "../../common/table/tr";
import Th from "../../common/table/th";
import TBody from "../../common/table/tBody";
import Td from "../../common/table/td";
import Row from "../../common/layout/row";
import Grid from "../../common/layout/grid";
import Button from "../../common/button/button.jsx";
import { ModalAlert } from "../../common/dialog/modalAlert.jsx";
import { Loading } from "../../common/loading/loading.jsx";
import { convertToBase64 } from "../../utils/convertToBase64.js";
import { gerarRelatorio } from "../../fatura/faturaActions.js";
import { useRef } from "react";
import { IndicadorComSetas } from "../components/IndicadorComSetas.jsx";
import { ArrowOrEqualIcon } from "../../common/arrowOrEqualIcon/ArrowOrEqualIcon.jsx";

function analiseContratoAluguel(props) {
    const dataAtual = new Date();

    // volta 1 mês
    dataAtual.setMonth(dataAtual.getMonth() - 1);

    const ano = dataAtual.getFullYear();
    const mes = String(dataAtual.getMonth() + 1).padStart(2, "0");

    const competenciaUltimoMes = Number(`${ano}${mes}`);

    if (!props.visible) return null;
    const fatorMultiplicadorTamanhoFonte = 1.4;
    const fontSizeTd = 0.71;

    const {
        state,
        listaGraficoAluguelUsinaMensal,
        listaEconomiaUsinaAluguelRemotasMensal,
        getListaGraficoCustoMensalUsinaAluguel,
        getListaEconomiaUsinaAluguelRemotasMensal,
        setAguardando,
        gerarRelatorio,
    } = props;

    const [loading, setLoading] = useState(false);
    const [competenciaEmFoco, setCompetenciaEmFoco] = useState(competenciaUltimoMes);
    const [modalExportacaoAberto, setModalExportacaoAberto] = useState(false);
    const [graficoMensalContratoAluguel, setGraficoMensalContratoAluguel] = useState(false);
    const [graficoEconomiaMensalRemotasContratoAluguel, setGraficoEconomiaMensalRemotasContratoAluguel] = useState(false);

    const fontSizePadrao = (modalExportacaoAberto ? fontSizeTd * fatorMultiplicadorTamanhoFonte : fontSizeTd) + "rem";
    const contentCardRef = useRef(null);
    const tableRef = useRef(null);

    const corDestaqueMesAtual = "#fff94f";
    const tamanhoColunaScroll = 518;

    useEffect(() => {
        atualizarTodosGraficos();
        return desmontarTodosGraficos;
    }, []);

    function desmontarTodosGraficos() {
        if (graficoMensalContratoAluguel) graficoMensalContratoAluguel.dispose();
    }

    useEffect(() => {
        const buscarDados = async () => {
            if (!state.aguardando) return;

            await Promise.all([getListaGraficoCustoMensalUsinaAluguel(), getListaEconomiaUsinaAluguelRemotasMensal()]);
            setAguardando(false);
        };

        buscarDados();
        if (!state.aguardando) {
            atualizarTodosGraficos();
            setCompetenciaEmFoco(competenciaUltimoMes);
        }
    }, [state.aguardando]);

    useEffect(() => {
        atualizarTodosGraficos();
    }, [modalExportacaoAberto]);

    function atualizarTodosGraficos() {
        atualizarListaGraficoMensalContratoAluguel();
        atualizarListaEconomiaUsinaAluguelRemotasMensal();

        //faz scroll horizontal para aparecer o mes atual em destaque na tabela
        if (!listaEconomiaUsinaAluguelRemotasMensal[0] || modalExportacaoAberto) return;
        const indiceCompetenciaAtual = cabecalho.findIndex((item) => item.competencia == competenciaUltimoMes);
        if (indiceCompetenciaAtual > 0) {
            const mesesQueDeveAvancar = indiceCompetenciaAtual;
            tableRef.current.scrollHorizontal(tamanhoColunaScroll * mesesQueDeveAvancar);
        }
    }

    function mapearListaGraficoColunasAgrupadas(lista) {
        return {
            dados: [...lista].map((item) => {
                const [mes, ano] = item.competencia.split("/");
                const anoAtual = new Date().getFullYear();
                let mesAtual = new Date().getMonth() + 1;
                mesAtual = mesAtual < 10 ? "0" + mesAtual : mesAtual;
                const competenciaItem = parseInt(`${ano}${mes}`);
                const competenciaAtual = parseInt(`${anoAtual}${mesAtual}`);
                const exibirAlerta = item.pendentes.length && competenciaItem <= competenciaAtual;

                const valor_fatura_simulado_bullet_tooltip = exibirAlerta
                    ? item.pendentes.reduce(
                          (acc, atual, i, array) =>
                              (acc +=
                                  i == 0
                                      ? `Faltam faturas nas UCs:\n${String(atual).split(" - ")[0]}\n`
                                      : i == array.length - 1
                                        ? `${atual}`.split(" - ")[0]
                                        : `${String(atual).split(" - ")[0]}\n`),
                          ""
                      )
                    : "";
                return {
                    ...item,
                    valor_fatura_simulado_bullet: valor_fatura_simulado_bullet_tooltip ? `Faltam \nfaturas\n(ver aqui)` : "",
                    valor_fatura_simulado_bullet_tooltip,
                    valor_resultado_percentual: `(${adicionarPontosMilhar(item.valor_fatura_simulado > 0 ? (item.valor_resultado * 100) / item.valor_fatura_simulado : 0)}%)`,
                };
            }),
            valuesAndNames: modoAnaliseContratoCompleto
                ? [
                      { value: "valor_fatura_simulado", name: "Faturas sem efeito de economia (simulado)", stacked: false, linePattern: false },
                      { value: "valor_fatura", name: "Valor da Fatura", stacked: false, linePattern: false },
                      { value: "valor_mensal_aluguel", name: "Valor Mensal Aluguel", stacked: true, linePattern: false },
                      { value: "valor_fatura_geradora", name: "Custo da Fatura da Usina Alugada", stacked: true, linePattern: false },
                      { value: "valor_resultado", name: "Resultado", stacked: true, linePattern: true },
                  ]
                : [
                      { value: "valor_fatura_simulado", name: "Faturas sem efeito de economia (simulado)", stacked: false, linePattern: false },
                      { value: "valor_fatura", name: "Valor da Fatura", stacked: false, linePattern: false },
                      { value: "valor_resultado", name: "Resultado", stacked: true, linePattern: true },
                  ],
        };
    }

    function atualizarListaGraficoMensalContratoAluguel() {
        const { dados, valuesAndNames } = mapearListaGraficoColunasAgrupadas(listaGraficoAluguelUsinaMensal);
        const graficoMensalContratoAluguelAtualizado = montarGraficoGroupStackedColumn({
            state: {
                cores: modoAnaliseContratoCompleto
                    ? [am4core.color("#0084ff"), am4core.color("#00d185"), am4core.color("#ffa037"), am4core.color("#6422ff"), am4core.color("#a6ffd0")]
                    : [am4core.color("#0084ff"), am4core.color("#00d185"), am4core.color("#a6ffd0")],
            },
            component: graficoMensalContratoAluguel,
            nome: "grafico-economia-mensal-usina-aluguel",
            dados,
            category: "competencia",
            valuesAndNames,
            titulo: ``,
            fontSizeTitle: 18,
            fontSizeLabel: modalExportacaoAberto ? fontSizePadrao : null,
            fontWeightTitle: "bolder",
            prefixo: "R$",
            sufixo: "",
            dimensions: "2D",
            mostrarLegenda: true,
            widthLegenda: modalExportacaoAberto ? 350 : null,
            chartBackground: "#30303d",
            bullets: true,
            individualBullets: true,
            individualBulletsColor: "#ff2a62",
            individualBulletsDy: 25,
            rotation: -45,
            showScrollBar: true,
            nameSerieBullets: "No cativo",
            dxIcone: 25,
            hideExport: true,
        });

        setGraficoMensalContratoAluguel(graficoMensalContratoAluguelAtualizado);
    }

    function atualizarListaEconomiaUsinaAluguelRemotasMensal() {
        const dados = listaEconomiaUsinaAluguelRemotasMensal.reduce(
            (acc, atual, i, lista) => {
                for (const mes of atual.meses) {
                    acc.quantidade_economia_fatura += parseFloat(mes.quantidade_economia_fatura) || 0;
                    acc.valor_economia_fatura += parseFloat(mes.valor_economia_fatura) || 0;
                }
                return acc;
            },
            {
                quantidade_economia_fatura: 0,
                valor_economia_fatura: 0,
            }
        );

        const graficoEconomiaMensalRemotasContratoAluguelAtualizado = montarGraficoColumn({
            state,
            component: graficoEconomiaMensalRemotasContratoAluguel,
            nome: "grafico-valores-faturas-remotas",
            dados: [
                {
                    nome: "kWh Recebidos nas Faturas",
                    valor: dados.quantidade_economia_fatura,
                    cor: am4core.color("#0084ff"),
                },
                {
                    nome: "R$ Recebidos nas Faturas",
                    valor: dados.valor_economia_fatura,
                    cor: am4core.color("#12ffb8"),
                },
            ],
            category: "nome",
            value: "valor",
            titulo: `Montantes Recebidos nas Faturas Remotas`,
            prefixo: "",
            sufixo: "",
            maxWidthLabel: window.innerWidth < 768 ? 100 : 240,
            fontSizeBullet: modalExportacaoAberto ? fatorMultiplicadorTamanhoFonte * 16 : 16,
            fontWeightBullet: "bold",
            positionBullet: -25,
            columnColorField: "cor",
            fontSizeXAxis: modalExportacaoAberto ? fatorMultiplicadorTamanhoFonte * 16 : 16,
            fontWeightXAxis: "bold",
            fontSizeTitle: modalExportacaoAberto ? fatorMultiplicadorTamanhoFonte * 20 : 20,
            fontWeightTitle: "bold",
        });

        setGraficoEconomiaMensalRemotasContratoAluguel(graficoEconomiaMensalRemotasContratoAluguelAtualizado);
    }

    function calcularTotal(lista) {
        return (lista || []).reduce(
            (acc, atual, i, array) => {
                const [mes, ano] = atual.competencia.split("/");
                const anoAtual = new Date().getFullYear();
                let mesAtual = new Date().getMonth() + 1;
                mesAtual = mesAtual < 10 ? "0" + mesAtual : mesAtual;
                const competenciaItem = parseInt(`${ano}${mes}`);
                const competenciaAtual = parseInt(`${anoAtual}${mesAtual}`);

                //só contabiliza os meses menor ou igual ao atual e somente dos meses que tem todas faturas importadas
                if (!atual.pendentes.length && competenciaItem <= competenciaAtual) {
                    if (i == 0) acc.competencia_inicial = atual.competencia;
                    acc.competencia_final = atual.competencia;
                    acc.valor_mensal_aluguel += parseFloat(atual.valor_mensal_aluguel);
                    acc.valor_fatura += parseFloat(atual.valor_fatura);
                    acc.valor_fatura_simulado += parseFloat(atual.valor_fatura_simulado);
                    acc.valor_fatura_geradora += parseFloat(atual.valor_fatura_geradora);
                    acc.valor_resultado += parseFloat(atual.valor_resultado);
                }
                return acc;
            },
            { valor_mensal_aluguel: 0, valor_fatura: 0, valor_fatura_geradora: 0, valor_fatura_simulado: 0, valor_resultado: 0, competencia_inicial: null, competencia_final: null }
        );
    }
    const total = calcularTotal(listaGraficoAluguelUsinaMensal);

    async function handleExport({ quantidadeTabelas, quantidadeUCs }) {
        setLoading(true);
        toggleScroll(true);

        const getTamanhoBase = () => {
            const zoomAtual = Math.floor(window.devicePixelRatio * 100);
            let tamanhoBase = 1750;
            if (window.innerWidth >= 768) {
                if (zoomAtual > 80 && zoomAtual <= 100) {
                    tamanhoBase = 1820;
                } else if (zoomAtual > 75 && zoomAtual <= 80) {
                    tamanhoBase = 1850;
                } else if (zoomAtual >= 70 && zoomAtual <= 75) {
                    tamanhoBase = 1900;
                } else if (zoomAtual >= 60 && zoomAtual <= 70) {
                    tamanhoBase = 2050;
                } else if (zoomAtual >= 50 && zoomAtual <= 60) {
                    tamanhoBase = 2450;
                } else if (zoomAtual < 50) {
                    return alert("Ajuste o zoom do navegador para 100% e tente novamente");
                }

                if (zoomAtual > 100 && zoomAtual <= 110) {
                    tamanhoBase = 1850;
                } else if (zoomAtual > 110 && zoomAtual <= 125) {
                    tamanhoBase = 1870;
                } else if (zoomAtual > 125 && zoomAtual <= 150) {
                    tamanhoBase = 2500;
                } else if (zoomAtual > 150 && zoomAtual <= 175) {
                    tamanhoBase = 4900;
                } else if (zoomAtual > 175) {
                    return alert("Ajuste o zoom do navegador para 100% e tente novamente");
                }
            }
            return tamanhoBase;
        };

        const calcularWidthGrafico = ({ el, zoom, desconto = 0 }) => {
            if (window.innerWidth < 768) {
                el.style.zoom = zoom || "0.80"; // ajusta de verdade o tamanho do elemento
                el.style.paddingLeft = "120px";
                // el.style.width = 2000 - desconto + "px";
            } else {
                el.style.zoom = "0.83";
                el.style.width = `${(window.devicePixelRatio < 1 ? 1 + (1 - window.devicePixelRatio) : 2 - window.devicePixelRatio) * getTamanhoBase() - desconto}px`;
                if (getTamanhoBase() == 2500) {
                    el.style.paddingLeft = "70px";
                    el.style.width = 1180 - desconto + "px";
                }
                if (getTamanhoBase() == 4900) {
                    el.style.paddingLeft = "120px";
                    el.style.width = 1105 - desconto + "px";
                }
            }
        };

        const formatarGrafico = ({ el, zoom }) => {
            if (el) {
                el.style.fontSize = 0.75 * fatorMultiplicadorTamanhoFonte + "rem";
                calcularWidthGrafico({ el, zoom });
                el.style.backgroundColor = "#30303d";
                el.style.overflowY = "hidden";
            }
        };

        const calcularWidthTabela = ({ el, desconto = 0 }) => {
            if (window.innerWidth < 768) {
                el.style.fontSize = 0.7 * fatorMultiplicadorTamanhoFonte + "rem";
                el.style.zoom = "0.80"; // ajusta de verdade o tamanho do elemento
                el.style.width = 1500 - desconto + "px";
            } else {
                el.style.minWidth = `${(window.devicePixelRatio < 1 ? 1 + (1 - window.devicePixelRatio) : 2 - window.devicePixelRatio) * getTamanhoBase() - desconto}px`;
                el.style.zoom = "0.85";
            }
        };

        const formatarTabela = ({ el }) => {
            if (el) {
                calcularWidthTabela({ el });
                el.style.color = "#FFFFFF";
                el.style.backgroundColor = "#30303d";
                el.style.marginTop = "10px";
                el.style.marginBottom = "10px";
                el.style.borderCollapse = "collapse";
                // el.style.border = "1px solid #666682";

                // Aplica bordas também às células (th, td)
                // const celulas = el.querySelectorAll("th, td");
                // celulas.forEach((celula) => {
                //     if (heightCelula) {
                //         celula.style.height = heightCelula;
                //     }
                // });
                //     celula.style.border = "1px solid #666682";
                //     celula.style.padding = "8px"; // Adiciona padding para melhorar a aparência
                //     celula.style.textAlign = "left";

                //     // Remove botões dentro do próprio td (fora da div filha)
                //     celula.querySelectorAll("button").forEach((btn) => btn.remove());
                // });
            }
        };

        // if (titulo.current && totais.current && grafico.current && tabelaAlertas.current) {
        if (contentCardRef.current) {
            const tituloGraficoEconomiaMensalUsinaAluguelElement = contentCardRef.current.querySelector("#titulo-grafico-economia-mensal-usina-aluguel");
            const totaisGraficoEconomiaMensalUsinaAluguelElement = contentCardRef.current.querySelector("#totais-grafico-economia-mensal-usina-aluguel");
            const graficoEconomiaMensalUsinaAluguelElement = contentCardRef.current.querySelector("#grafico-economia-mensal-usina-aluguel");
            const tabelaGraficoEconomiaMensalUsinaAluguelElement = contentCardRef.current.querySelector("#tabela-grafico-economia-mensal-usina-aluguel");

            const graficoValoresFaturasRemotasElement = contentCardRef.current.querySelector("#grafico-valores-faturas-remotas");

            // Altera a largura e cor de fundo do gráfico antes de renderizar o conteúdo
            if (tituloGraficoEconomiaMensalUsinaAluguelElement) {
                tituloGraficoEconomiaMensalUsinaAluguelElement.style.fontSize = 1.4 * fatorMultiplicadorTamanhoFonte + "rem";
                tituloGraficoEconomiaMensalUsinaAluguelElement.style.color = "#FFF";
                tituloGraficoEconomiaMensalUsinaAluguelElement.style.margin = 0;
            }

            if (totaisGraficoEconomiaMensalUsinaAluguelElement) {
                totaisGraficoEconomiaMensalUsinaAluguelElement.style.marginBlock = "30px";
            }
            formatarGrafico({ el: graficoEconomiaMensalUsinaAluguelElement });
            formatarTabela({ el: tabelaGraficoEconomiaMensalUsinaAluguelElement });

            formatarGrafico({ el: graficoValoresFaturasRemotasElement });

            // Captura o HTML com os estilos atualizados
            const htmlTituloGraficoEconomiaMensalUsinaAluguelElement = tituloGraficoEconomiaMensalUsinaAluguelElement
                ? `<div style="width:100%; display:flex; justify-content:center; background-color:#30303d;"> ${tituloGraficoEconomiaMensalUsinaAluguelElement.outerHTML}</div>`
                : "";
            const htmlTotaisGraficoEconomiaMensalUsinaAluguelElement = totaisGraficoEconomiaMensalUsinaAluguelElement
                ? `<div style="width:100%; display:flex; justify-content:center; background-color:#30303d;"> ${totaisGraficoEconomiaMensalUsinaAluguelElement.outerHTML}</div>`
                : "";
            const htmlGraficoEconomiaMensalUsinaAluguelElement = graficoEconomiaMensalUsinaAluguelElement
                ? `<div style="padding-right:50px;width:calc(100% - 50px); display:flex; justify-content:center; background-color:#30303d;"> ${graficoEconomiaMensalUsinaAluguelElement.outerHTML}</div>`
                : "";
            const htmlTabelaGraficoEconomiaMensalUsinaAluguelElement = tabelaGraficoEconomiaMensalUsinaAluguelElement
                ? `<div style="width:100%; display:flex; justify-content:center; background-color:#30303d;"> ${tabelaGraficoEconomiaMensalUsinaAluguelElement.outerHTML}</div>`
                : "";

            const htmlGraficoValoresFaturasRemotasElement = graficoValoresFaturasRemotasElement
                ? `<div style="width:100%; display:flex; justify-content:center; background-color:#30303d;"> ${graficoValoresFaturasRemotasElement.outerHTML}</div>`
                : "";

            let listaHtmlTabelasGraficoValoresFaturasRemotas = "";

            for (let i = 0; i < quantidadeTabelas; i++) {
                const tabelaGraficoValoresFaturasRemotasElement = contentCardRef.current.querySelector(`#tabela-grafico-valores-faturas-remotas-${i}`);
                formatarTabela({ el: tabelaGraficoValoresFaturasRemotasElement });
                const htmlTabelaGraficoValoresFaturasRemotasElement = tabelaGraficoValoresFaturasRemotasElement
                    ? `<div style="width:100%; display:flex;justify-content:center; background-color:#30303d;"> ${tabelaGraficoValoresFaturasRemotasElement.outerHTML}</div>`
                    : "";

                listaHtmlTabelasGraficoValoresFaturasRemotas += htmlTabelaGraficoValoresFaturasRemotasElement;
            }

            const base64Cabecalho = await convertToBase64("/images/cabecalho_relatorio.png");
            const htmlCabecalho = `<div style="border: 1px solid #DDD; font-family: Arial, sans-serif;">
                                            <div style="width:100%; height:10%;">
                                                <img src="${base64Cabecalho}" width="100%" />
                                            </div>
                                             <div style="width:100%; height:84%;">
                                               `;

            const base64Rodape = await convertToBase64("/images/rodape_relatorio.png");
            const htmlRodape = `</div>
                                    <div style="width:100%; height:5%; display:flex; flex-direction:column; align-items:center; justify-content:flex-end;">
                                            <img src="${base64Rodape}" width="100%" />
                                        </div>
                                    </div> `;

            const tudoNaMesmaPagina = quantidadeTabelas < 2 && quantidadeUCs < 5;
            // Combina o HTML atualizado dos três elementos
            const html = tudoNaMesmaPagina
                ? htmlCabecalho +
                  '<div style="display:flex;flex-direction:column;width:100%;height:23%;background-color:#30303d;align-items:center;justify-content:center;">' +
                  htmlTituloGraficoEconomiaMensalUsinaAluguelElement +
                  htmlTotaisGraficoEconomiaMensalUsinaAluguelElement +
                  "</div>" +
                  '<div style="display:flex;flex-direction:column;width:100%;height:43%;background-color:#30303d;align-items:center;justify-content:center;">' +
                  htmlGraficoEconomiaMensalUsinaAluguelElement +
                  htmlTabelaGraficoEconomiaMensalUsinaAluguelElement +
                  htmlGraficoValoresFaturasRemotasElement +
                  "</div>" +
                  '<div style="display:flex;flex-direction:column;width:100%;height:33%;background-color:#30303d;align-items:center;justify-content:center;">' +
                  listaHtmlTabelasGraficoValoresFaturasRemotas +
                  "</div>" +
                  htmlRodape
                : htmlCabecalho +
                  '<div style="display:flex;flex-direction:column;width:100%;height:23%;background-color:#30303d;align-items:center;justify-content:center;">' +
                  htmlTituloGraficoEconomiaMensalUsinaAluguelElement +
                  htmlTotaisGraficoEconomiaMensalUsinaAluguelElement +
                  "</div>" +
                  '<div style="display:flex;flex-direction:column;width:100%;height:33%;background-color:#30303d;align-items:center;justify-content:center;">' +
                  htmlGraficoEconomiaMensalUsinaAluguelElement +
                  htmlTabelaGraficoEconomiaMensalUsinaAluguelElement +
                  "</div>" +
                  '<div style="display:flex;flex-direction:column;width:100%;height:43%;background-color:#30303d;align-items:center;justify-content:center;">' +
                  htmlGraficoValoresFaturasRemotasElement +
                  "</div>" +
                  htmlRodape +
                  htmlCabecalho +
                  '<div style="display:flex;flex-direction:column;width:100%;height:99%;background-color:#30303d;align-items:center;justify-content:flex-start;">' +
                  listaHtmlTabelasGraficoValoresFaturasRemotas +
                  "</div>" +
                  htmlRodape;
            // const html = htmlCabecalho + htmlTitulo + htmlTotais + htmlGrafico + htmlRodape;

            // Gera o relatório com o HTML atualizado
            await gerarRelatorio({
                html,
                landscape: false,
                scale: window.innerWidth < 768 ? 0.45 : window.devicePixelRatio * 0.42,
            });
            toggleScroll(false);
            setLoading(false);
        } else {
            console.error("ContentCard não está acessível.");
        }
    }

    const listaAnos = listaGraficoAluguelUsinaMensal.reduce((acc, atual) => {
        const [mes, ano] = atual.competencia.split("/");
        if (!acc.includes(ano) && ano <= new Date().getFullYear()) {
            acc.push(ano);
        }
        return acc;
    }, []);
    listaAnos.sort((a, b) => b - a);

    function montarCelulas(item) {
        const linhaExtra = modalExportacaoAberto ? null : (
            <Tr>
                <Td fontSize={fontSizePadrao} style={{ border: 0 }} minWidth={120} alignCenter>
                    <div style={{ height: 10 }}></div>
                </Td>
            </Tr>
        );
        return (
            <table>
                <tbody>
                    {linhaExtra}
                    {modoAnaliseContratoCompleto && (
                        <Tr>
                            <Td
                                fontSize={fontSizePadrao}
                                style={{ border: 0 }}
                                minWidth={120}
                                title="Custo da Fatura da Usina Alugada"
                                backgroundColor="#6422ff"
                                color="#FFF"
                                alignCenter
                            >
                                {item ? "R$" + adicionarPontosMilhar(parseFloat(item.valor_fatura_geradora)) : "-"}
                            </Td>
                        </Tr>
                    )}
                    <Tr>
                        <Td
                            fontSize={fontSizePadrao}
                            style={{ border: 0 }}
                            minWidth={120}
                            title="Faturas sem efeito de economia (simulado)"
                            backgroundColor="#0084ff"
                            color="#FFF"
                            alignCenter
                        >
                            {item ? "R$" + adicionarPontosMilhar(parseFloat(item.valor_fatura_simulado)) : "-"}
                        </Td>
                    </Tr>

                    {modoAnaliseContratoCompleto && (
                        <Tr>
                            <Td fontSize={fontSizePadrao} style={{ border: 0 }} minWidth={120} title="Valor Mensal Aluguel" backgroundColor="#ffa037" color="#FFF" alignCenter>
                                {item ? "R$" + adicionarPontosMilhar(parseFloat(item.valor_mensal_aluguel)) : "-"}
                            </Td>
                        </Tr>
                    )}
                    <Tr>
                        <Td fontSize={fontSizePadrao} style={{ border: 0 }} minWidth={120} title="Valor da Fatura" backgroundColor="#00d185" color="#FFF" alignCenter>
                            <div
                                style={{
                                    height: 17,
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}
                            >
                                {item ? "R$" + adicionarPontosMilhar(parseFloat(item.valor_fatura)) : "-"}
                            </div>
                        </Td>
                    </Tr>
                    <Tr>
                        <Td fontSize={fontSizePadrao} style={{ border: 0 }} minWidth={120} title="Resultado" backgroundColor="#a6ffd0" color="#222" alignCenter>
                            <div
                                style={{
                                    height: 17,
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}
                            >
                                {item ? "R$" + adicionarPontosMilhar(parseFloat(item.valor_resultado)) : "-"}
                            </div>
                        </Td>
                    </Tr>
                    {linhaExtra}
                </tbody>
            </table>
        );
    }

    function bloquearScroll(e) {
        e.preventDefault();
    }

    function toggleScroll(bloquear) {
        if (bloquear) {
            document.body.style.overflowY = "hidden";
            window.addEventListener("wheel", bloquearScroll, { passive: false });
            window.addEventListener("touchmove", bloquearScroll, { passive: false });
        } else {
            document.body.style.overflowY = "auto";
            window.removeEventListener("wheel", bloquearScroll);
            window.removeEventListener("touchmove", bloquearScroll);
        }
    }

    const maiorQtdMeses = listaEconomiaUsinaAluguelRemotasMensal.reduce((acc, item) => {
        return Math.max(acc, parseFloat(item.meses.length) || 0);
    }, 0);

    const colunasPorTabela = maiorQtdMeses <= 15 ? maiorQtdMeses : maiorQtdMeses <= 30 ? Math.ceil(maiorQtdMeses / 2) : Math.ceil(maiorQtdMeses / 3);
    const quantidadeTabelas = Math.ceil(maiorQtdMeses / colunasPorTabela);

    const listaTabelas = Array.from({ length: quantidadeTabelas }, (_, indice) => ({
        indice,
        indiceInicial: indice * colunasPorTabela,
        indiceFinal: (indice + 1) * colunasPorTabela,
    }));
    // console.log({ maiorQtdMeses, quantidadeTabelas, listaTabelas });

    const modoAnaliseContratoCompleto = !props.filtro.id_unidade_remota_contrato_aluguel;

    const cabecalho = listaEconomiaUsinaAluguelRemotasMensal[0] ? listaEconomiaUsinaAluguelRemotasMensal[0].meses : [];
    return (
        <div ref={contentCardRef}>
            {loading ? <Loading /> : null}
            {loading || modalExportacaoAberto ? <div style={{ height: "100vh", width: "100%" }}></div> : null}
            <ContentCard
                style={{
                    color: "#fff",
                    padding: 8,
                }}
            >
                <ContentCardBody
                    style={{
                        backgroundColor: "#30303d",
                    }}
                >
                    <Row alignRight style={{ paddingRight: 5 }}>
                        <Grid cols="12 12 2 2" style={{ display: "flex", justifyContent: "flex-end" }}>
                            <Button
                                style={{ width: window.innerWidth < 768 ? "50%" : 120 }}
                                text={<span style={{ fontSize: "0.75rem", whiteSpace: "nowrap" }}>Exportar</span>}
                                title="Exportar"
                                type={"light"}
                                icon={"fa fa-file-export"}
                                event={() => setModalExportacaoAberto(true)}
                            />
                        </Grid>
                    </Row>
                    {modalExportacaoAberto ? (
                        <ModalAlert handleClose={() => setModalExportacaoAberto(false)}>
                            <div className="d-flex flex-column justify-content-center align-items-center text-dark">
                                <p>Deseja realmente exportar a análise de contrato de aluguel?</p>
                            </div>
                            <Row alignRight style={{ paddingRight: 5 }}>
                                <Grid cols="2 2 2 2"></Grid>
                                <Grid cols="4 4 4 4">
                                    <Button
                                        text={<span style={{ fontSize: "clamp(0.6rem, 2vw, 1rem)", whiteSpace: "nowrap" }}>Sim</span>}
                                        type={"info"}
                                        icon={"fas fa-check"}
                                        event={() => {
                                            handleExport({ quantidadeTabelas, quantidadeUCs: (listaEconomiaUsinaAluguelRemotasMensal || []).length });
                                            setModalExportacaoAberto(false);
                                        }}
                                    />
                                </Grid>
                                <Grid cols="4 4 4 4">
                                    <Button
                                        text={<span style={{ fontSize: "clamp(0.6rem, 2vw, 1rem)", whiteSpace: "nowrap" }}>Não</span>}
                                        type={"dark"}
                                        icon={"fas fa-times"}
                                        event={() => {
                                            setModalExportacaoAberto(false);
                                        }}
                                    />
                                </Grid>
                                <Grid cols="2 2 2 2"></Grid>
                            </Row>
                        </ModalAlert>
                    ) : null}
                    {state.aguardando ? (
                        <div style={{ height: "100vh", display: "flex", justifyContent: "center" }}>
                            <Loading />
                        </div>
                    ) : (
                        <>
                            <div>
                                <div id="titulo-grafico-economia-mensal-usina-aluguel" className="d-flex justify-content-center" style={{ marginTop: 60, marginBottom: 30 }}>
                                    <h5>Economia Mensal do Aluguel de Usina (R$)</h5>
                                </div>
                                <div id="totais-grafico-economia-mensal-usina-aluguel" className="d-flex justify-content-center">
                                    <table style={{ backgroundColor: "#e4e5f1", color: "#000000", fontSize: "0.75rem", borderRadius: 10 }}>
                                        <tbody>
                                            {modoAnaliseContratoCompleto && (
                                                <tr style={{ borderBottom: "1px solid #444" }}>
                                                    <td style={{ fontSize: fontSizePadrao, border: 0, fontWeight: "bold", padding: "5px 20px" }}>Período Considerado</td>
                                                    <td style={{ fontSize: fontSizePadrao, border: 0, width: 300, padding: "10px 25px" }}>
                                                        {(total.competencia_inicial || " - ") + " até " + (total.competencia_final || " - ")}
                                                    </td>
                                                </tr>
                                            )}
                                            {modoAnaliseContratoCompleto && (
                                                <tr style={{ borderBottom: "1px solid #444" }}>
                                                    <td style={{ fontSize: fontSizePadrao, border: 0, fontWeight: "bold", padding: "5px 20px" }}>Faturas Usina Alugada</td>
                                                    <td style={{ fontSize: fontSizePadrao, border: 0, width: 300, padding: "10px 25px" }}>
                                                        {"R$ " + adicionarPontosMilhar(total.valor_fatura_geradora)}
                                                    </td>
                                                </tr>
                                            )}
                                            <tr style={{ borderBottom: "1px solid #444" }}>
                                                <td style={{ fontSize: fontSizePadrao, border: 0, fontWeight: "bold", padding: "5px 20px" }}>
                                                    Faturas sem efeito de economia (simulado)
                                                </td>
                                                <td style={{ fontSize: fontSizePadrao, border: 0, width: 300, padding: "10px 25px" }}>
                                                    {"R$ " + adicionarPontosMilhar(total.valor_fatura_simulado)}
                                                </td>
                                            </tr>
                                            {modoAnaliseContratoCompleto ? (
                                                <tr style={{ borderBottom: "1px solid #444" }}>
                                                    <td style={{ fontSize: fontSizePadrao, border: 0, fontWeight: "bold", padding: "5px 20px" }}>Custo Aluguel + Fatura</td>
                                                    <td style={{ fontSize: fontSizePadrao, border: 0, width: 300, padding: "10px 25px" }}>
                                                        {"R$ " + adicionarPontosMilhar(total.valor_mensal_aluguel + total.valor_fatura)}
                                                    </td>
                                                </tr>
                                            ) : (
                                                <tr style={{ borderBottom: "1px solid #444" }}>
                                                    <td style={{ fontSize: fontSizePadrao, border: 0, fontWeight: "bold", padding: "5px 20px" }}>Fatura</td>
                                                    <td style={{ fontSize: fontSizePadrao, border: 0, width: 300, padding: "10px 25px" }}>
                                                        {"R$ " + adicionarPontosMilhar(total.valor_fatura)}
                                                    </td>
                                                </tr>
                                            )}
                                            <tr>
                                                <td style={{ fontSize: fontSizePadrao, border: 0, fontWeight: "bold", padding: "5px 20px" }}>Resultado</td>
                                                <td
                                                    style={{
                                                        fontSize: fontSizePadrao,
                                                        border: 0,
                                                        width: 300,
                                                        padding: "5px 20px",
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            backgroundColor: total.valor_resultado < 0 ? "#ff3045" : total.valor_resultado > 0 ? "#2df493" : null,
                                                            padding: 5,
                                                            borderRadius: 5,
                                                        }}
                                                    >
                                                        {total.valor_resultado < 0 && <i style={{ margin: 5 }} className={"fas fa-arrow-alt-circle-down"}></i>}
                                                        {total.valor_resultado > 0 && <i style={{ margin: 5 }} className={"fas fa-arrow-alt-circle-up"}></i>}
                                                        {"R$ " +
                                                            adicionarPontosMilhar(total.valor_resultado) +
                                                            ` (${adicionarPontosMilhar(
                                                                (total.valor_resultado < 0 ? 0 : (total.valor_resultado * 100) / total.valor_fatura_simulado) || 0
                                                            )}% Economizado)`}
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <ContentCardBody style={{ overflowX: "auto" }}>
                                <div
                                    id="grafico-economia-mensal-usina-aluguel"
                                    style={{
                                        width: "100%",
                                        minWidth: window.innerWidth < 768 ? 1800 : 890,
                                        height: "400px",
                                    }}
                                ></div>
                                <Table id="tabela-grafico-economia-mensal-usina-aluguel" scrollX="unset" minWidth={window.innerWidth < 768 ? 1800 : 890}>
                                    <THead>
                                        <Tr>
                                            <Th style={{ fontSize: fontSizePadrao }} alignCenter>
                                                Ano
                                            </Th>
                                            <Th style={{ fontSize: fontSizePadrao }} alignCenter>
                                                Janeiro
                                            </Th>
                                            <Th style={{ fontSize: fontSizePadrao }} alignCenter>
                                                Fevereiro
                                            </Th>
                                            <Th style={{ fontSize: fontSizePadrao }} alignCenter>
                                                Março
                                            </Th>
                                            <Th style={{ fontSize: fontSizePadrao }} alignCenter>
                                                Abril
                                            </Th>
                                            <Th style={{ fontSize: fontSizePadrao }} alignCenter>
                                                Maio
                                            </Th>
                                            <Th style={{ fontSize: fontSizePadrao }} alignCenter>
                                                Junho
                                            </Th>
                                            <Th style={{ fontSize: fontSizePadrao }} alignCenter>
                                                Julho
                                            </Th>
                                            <Th style={{ fontSize: fontSizePadrao }} alignCenter>
                                                Agosto
                                            </Th>
                                            <Th style={{ fontSize: fontSizePadrao }} alignCenter>
                                                Setembro
                                            </Th>
                                            <Th style={{ fontSize: fontSizePadrao }} alignCenter>
                                                Outubro
                                            </Th>
                                            <Th style={{ fontSize: fontSizePadrao }} alignCenter>
                                                Novembro
                                            </Th>
                                            <Th style={{ fontSize: fontSizePadrao }} alignCenter>
                                                Dezembro
                                            </Th>
                                            <Th style={{ fontSize: fontSizePadrao }} alignCenter>
                                                Resultado Parcial
                                            </Th>
                                        </Tr>
                                    </THead>
                                    <TBody>
                                        {listaAnos.map((ano) => {
                                            const mesesAno = listaGraficoAluguelUsinaMensal.filter((item) => item.competencia.split("/")[1] == ano);
                                            const totalAno = calcularTotal(mesesAno);

                                            const widthTdResultado = modalExportacaoAberto ? 200 : 150

                                            return (
                                                <Tr key={ano} style={{ borderBottom: "1px solid #FFF" }}>
                                                    <Td style={{ fontSize: fontSizePadrao, border: 0 }} minWidth={80} alignCenter color="#FFF">
                                                        {ano}
                                                    </Td>
                                                    {mesesAno.map((item, i, lista) => {
                                                        const [mes, ano] = item.competencia.split("/");

                                                        // adiciona TDs vazios antes do primeiro mês
                                                        if (i === 0 && mes > 1) {
                                                            return (
                                                                <>
                                                                    {Array.from({ length: mes - 1 }).map((_, indiceMesFaltante) => (
                                                                        <Td style={{ fontSize: fontSizePadrao, border: 0 }} alignCenter key={`empty-${indiceMesFaltante}`}>
                                                                            {montarCelulas()}
                                                                        </Td>
                                                                    ))}
                                                                    <Td style={{ fontSize: fontSizePadrao, border: 0 }} alignCenter key={item.competencia}>
                                                                        {montarCelulas(item)}
                                                                    </Td>
                                                                </>
                                                            );
                                                        } else if (i === lista.length - 1 && mes < 12) {
                                                            return (
                                                                <>
                                                                    <Td style={{ fontSize: fontSizePadrao, border: 0 }} alignCenter key={item.competencia}>
                                                                        {montarCelulas(item)}
                                                                    </Td>
                                                                    {Array.from({ length: 12 - mes }).map((_, indiceMesFaltante) => (
                                                                        <Td style={{ fontSize: fontSizePadrao, border: 0 }} alignCenter key={`empty-${indiceMesFaltante}`}>
                                                                            {montarCelulas()}
                                                                        </Td>
                                                                    ))}
                                                                </>
                                                            );
                                                        } else {
                                                            return (
                                                                <Td style={{ fontSize: fontSizePadrao, border: 0 }} alignCenter key={item.competencia}>
                                                                    {montarCelulas(item)}
                                                                </Td>
                                                            );
                                                        }
                                                    })}
                                                    <Td style={{ fontSize: fontSizePadrao, border: 0 }} alignCenter width={widthTdResultado}>
                                                        <div style={{ borderRadius: 8, overflow: "hidden", width: widthTdResultado }}>
                                                            <table>
                                                                <tbody>
                                                                    {modoAnaliseContratoCompleto && (
                                                                        <Tr>
                                                                            <Td
                                                                                fontSize={fontSizePadrao}
                                                                                style={{ border: 0 }}
                                                                                width={widthTdResultado}
                                                                                title="Custo da Fatura da Usina Alugada"
                                                                                backgroundColor="#e4e5f1"
                                                                                color="#222"
                                                                                alignCenter
                                                                                borderBottom="1px solid #222"
                                                                            >
                                                                                {"R$ " + adicionarPontosMilhar(totalAno.valor_fatura_geradora)}
                                                                            </Td>
                                                                        </Tr>
                                                                    )}
                                                                    <Tr>
                                                                        <Td
                                                                            fontSize={fontSizePadrao}
                                                                            style={{ border: 0 }}
                                                                            width={widthTdResultado}
                                                                            title="Faturas sem efeito de economia (simulado)"
                                                                            backgroundColor="#e4e5f1"
                                                                            color="#222"
                                                                            alignCenter
                                                                            borderBottom="1px solid #222"
                                                                        >
                                                                            {"R$ " + adicionarPontosMilhar(totalAno.valor_fatura_simulado)}
                                                                        </Td>
                                                                    </Tr>

                                                                    {modoAnaliseContratoCompleto ? (
                                                                        <>
                                                                            <Tr>
                                                                                <Td
                                                                                    rowSpan={2}
                                                                                    fontSize={fontSizePadrao}
                                                                                    style={{ border: 0 }}
                                                                                    width={widthTdResultado}
                                                                                    backgroundColor="#e4e5f1"
                                                                                    color="#222"
                                                                                    alignCenter
                                                                                    title="Custo Aluguel + Fatura"
                                                                                >
                                                                                    <div
                                                                                        style={{
                                                                                            width: widthTdResultado,
                                                                                            marginBlock: 10,
                                                                                            borderRadius: 4,
                                                                                        }}
                                                                                    >
                                                                                        {"R$ " + adicionarPontosMilhar(totalAno.valor_mensal_aluguel + totalAno.valor_fatura)}
                                                                                    </div>
                                                                                </Td>
                                                                            </Tr>
                                                                            <Tr></Tr>
                                                                        </>
                                                                    ) : (
                                                                        <Tr>
                                                                            <Td
                                                                                fontSize={fontSizePadrao}
                                                                                style={{ border: 0 }}
                                                                                width={widthTdResultado}
                                                                                backgroundColor="#e4e5f1"
                                                                                color="#FFF"
                                                                                alignCenter
                                                                                title="Fatura"
                                                                            >
                                                                                <div
                                                                                    style={{
                                                                                        width: widthTdResultado,
                                                                                        borderRadius: 4,
                                                                                        position: "relative",
                                                                                        zIndex: 1,
                                                                                        color: "#222",
                                                                                    }}
                                                                                >
                                                                                    {"R$ " + adicionarPontosMilhar(totalAno.valor_fatura)}
                                                                                </div>
                                                                            </Td>
                                                                        </Tr>
                                                                    )}

                                                                    <Tr>
                                                                        <Td
                                                                            fontSize={fontSizePadrao}
                                                                            style={{ border: 0 }}
                                                                            width={widthTdResultado}
                                                                            title="Resultado"
                                                                            backgroundColor="#a6ffd0"
                                                                            color="#222"
                                                                            alignCenter
                                                                        >
                                                                            <div
                                                                                style={{
                                                                                    height: 17,
                                                                                    backgroundColor:
                                                                                        totalAno.valor_resultado < 0 ? "#ff3045" : totalAno.valor_resultado > 0 ? "#2df493" : null,
                                                                                    borderRadius: 5,
                                                                                    display: "flex",
                                                                                    justifyContent: "center",
                                                                                    alignItems: "center",
                                                                                }}
                                                                            >
                                                                                {totalAno.valor_resultado < 0 && (
                                                                                    <i style={{ margin: 5 }} className={"fas fa-arrow-alt-circle-down"}></i>
                                                                                )}
                                                                                {totalAno.valor_resultado > 0 && (
                                                                                    <i style={{ margin: 5 }} className={"fas fa-arrow-alt-circle-up"}></i>
                                                                                )}
                                                                                {"R$ " +
                                                                                    adicionarPontosMilhar(totalAno.valor_resultado) +
                                                                                    ` (${adicionarPontosMilhar(
                                                                                        (totalAno.valor_resultado < 0
                                                                                            ? 0
                                                                                            : (totalAno.valor_resultado * 100) / totalAno.valor_fatura_simulado) || 0
                                                                                    )}%)`}
                                                                            </div>
                                                                        </Td>
                                                                    </Tr>
                                                                    {/* <Tr>
                                                                        <Td fontSize={fontSizePadrao} style={{ border: 0 }} minWidth={180} alignCenter>
                                                                            <div style={{ height: 10 }}></div>
                                                                        </Td>
                                                                    </Tr> */}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </Td>
                                                </Tr>
                                            );
                                        })}
                                    </TBody>
                                </Table>
                            </ContentCardBody>
                            <ContentCardBody style={{ overflowX: "auto" }}>
                                <div
                                    id="grafico-valores-faturas-remotas"
                                    style={{
                                        marginBlock: 50,
                                        width: "100%",
                                        minWidth: window.innerWidth < 768 ? 1800 : 890,
                                        height: "400px",
                                    }}
                                ></div>
                                {listaEconomiaUsinaAluguelRemotasMensal.length > 0 &&
                                    (modalExportacaoAberto ? (
                                        listaTabelas.map((tabela, index) => {
                                            const colunasForaDoBloco = cabecalho.filter((_, i) => i < tabela.indiceInicial || i >= tabela.indiceFinal).length;

                                            const maxWidth = colunasForaDoBloco ? `${100 / colunasForaDoBloco}%` : "100%";
                                            return (
                                                <Table key={index} id={"tabela-grafico-valores-faturas-remotas-" + tabela.indice} responsive maxWidth={maxWidth}>
                                                    <THead>
                                                        <Tr>
                                                            <Th backgroundColor="#2736cb" alignCenter style={{ padding: 10, fontSize: fontSizePadrao }}>
                                                                <div style={{ display: "flex", alignItems: "center" }}>UCs</div>
                                                            </Th>
                                                            <Th backgroundColor="#2736cb" alignCenter style={{ padding: 10, fontSize: fontSizePadrao }} minWidth={100}>
                                                                <div style={{ display: "flex", alignItems: "center" }}>Descrição</div>
                                                            </Th>
                                                            {cabecalho.map((item, i) => {
                                                                if (i < tabela.indiceInicial || i >= tabela.indiceFinal) return null;
                                                                return (
                                                                    <Th
                                                                        backgroundColor={i % 2 == 0 ? "#5050fd" : "#3d3db8"}
                                                                        alignCenter
                                                                        minWidth={120}
                                                                        style={{ fontSize: fontSizePadrao }}
                                                                    >
                                                                        {String(item.competencia).substring(4, 6) + "/" + String(item.competencia).substring(0, 4)}
                                                                    </Th>
                                                                );
                                                            })}
                                                        </Tr>
                                                    </THead>
                                                    <TBody>
                                                        {listaEconomiaUsinaAluguelRemotasMensal.map((item) => {
                                                            return (
                                                                <Tr key={item.id_unidade_remota} style={{ borderBottom: "1px solid #FFF" }}>
                                                                    <Td width="150px" backgroundColor="#2736cb" color="#FFF" fontSize={fontSizePadrao}>
                                                                        {item.nome_unidade_consumidora}
                                                                    </Td>
                                                                    <Td backgroundColor="#2736cb" color="#FFF" fontSize={fontSizePadrao}>
                                                                        <div style={{ borderBottom: "1px solid #FFF", height: 20 }}>kWh Recebidos</div>
                                                                        <div style={{ borderBottom: "1px solid #FFF", height: 20 }}>R$ Recebidos</div>
                                                                        <div style={{ borderBottom: "1px solid #FFF", height: 40 }}>Anexo G</div>
                                                                        <div style={{ height: 40 }}>Saldos</div>
                                                                    </Td>
                                                                    {item.meses.map((mes, i) => {
                                                                        if (i < tabela.indiceInicial || i >= tabela.indiceFinal) return null;

                                                                        return (
                                                                            <Td
                                                                                minWidth={120}
                                                                                backgroundColor={i % 2 == 0 ? "#30303d" : "#272730"}
                                                                                color="#FFF"
                                                                                alignCenter
                                                                                fontSize={fontSizePadrao}
                                                                            >
                                                                                <div style={{ borderBottom: "1px solid #FFF", height: 20 }}>
                                                                                    {adicionarPontosMilhar(mes.quantidade_economia_fatura)}
                                                                                </div>
                                                                                <div style={{ borderBottom: "1px solid #FFF", height: 20 }}>
                                                                                    {adicionarPontosMilhar(mes.valor_economia_fatura)}
                                                                                </div>
                                                                                <div style={{ borderBottom: "1px solid #FFF", height: 40 }}>
                                                                                    <div title="Percentual gerado pela própria UC">
                                                                                        {"G. Próp.: " + adicionarPontosMilhar(mes.percentual_geracao)}
                                                                                    </div>
                                                                                    <div title={mes.percentual_geracao_externa ? "Percentual recebido de usina alugada" : null}>
                                                                                        {mes.percentual_geracao_externa
                                                                                            ? "G. Alug.: " + adicionarPontosMilhar(mes.percentual_geracao_externa)
                                                                                            : null}
                                                                                    </div>
                                                                                </div>
                                                                                <div style={{ height: 40 }}>
                                                                                    <div>
                                                                                        {adicionarPontosMilhar(mes.saldo_geracao)}{" "}
                                                                                        <ArrowOrEqualIcon iconName={getNomeIconeSaldo(mes.variacao_saldo_geracao)} />
                                                                                    </div>
                                                                                    {mes.saldo_geracao_ponta ? (
                                                                                        <div>
                                                                                            {"P: " + adicionarPontosMilhar(mes.saldo_geracao_ponta)}{" "}
                                                                                            <ArrowOrEqualIcon iconName={getNomeIconeSaldo(mes.variacao_saldo_geracao_ponta)} />
                                                                                        </div>
                                                                                    ) : null}
                                                                                    {mes.saldo_geracao_fora_ponta ? (
                                                                                        <div>
                                                                                            {"FP: " + adicionarPontosMilhar(mes.saldo_geracao_fora_ponta)}{" "}
                                                                                            <ArrowOrEqualIcon iconName={getNomeIconeSaldo(mes.variacao_saldo_geracao_fora_ponta)} />
                                                                                        </div>
                                                                                    ) : null}
                                                                                </div>
                                                                            </Td>
                                                                        );
                                                                    })}
                                                                </Tr>
                                                            );
                                                        })}
                                                        <Tr>
                                                            <Th backgroundColor="#1cc666" color="#FFF" style={{ padding: 10, fontSize: fontSizePadrao }}>
                                                                <div style={{ display: "flex", alignItems: "center" }}>Total</div>
                                                            </Th>
                                                            <Th backgroundColor="#1cc666" color="#FFF" style={{ fontSize: fontSizePadrao }}>
                                                                <div style={{ borderBottom: "1px solid #FFF", height: 20 }}>kWh Recebidos</div>
                                                                <div style={{ borderBottom: "1px solid #FFF", height: 20 }}>R$ Recebidos</div>
                                                                <div style={{ borderBottom: "1px solid #FFF", height: 40 }}>Anexo G</div>
                                                                <div style={{ height: 40 }}>Saldos</div>
                                                            </Th>
                                                            {cabecalho.map((itemMes, i) => {
                                                                if (i < tabela.indiceInicial || i >= tabela.indiceFinal) return null;

                                                                return (
                                                                    <Th
                                                                        key={i}
                                                                        backgroundColor={i % 2 == 0 ? "#2ddc79" : "#1cc666"}
                                                                        color="#FFF"
                                                                        alignCenter
                                                                        style={{ fontSize: fontSizePadrao }}
                                                                    >
                                                                        <div style={{ borderBottom: "1px solid #FFF", height: 20 }}>
                                                                            {adicionarPontosMilhar(itemMes.total_quantidade_economia_fatura)}
                                                                        </div>
                                                                        <div style={{ borderBottom: "1px solid #FFF", height: 20 }}>
                                                                            {adicionarPontosMilhar(itemMes.total_valor_economia_fatura)}
                                                                        </div>
                                                                        <div style={{ borderBottom: "1px solid #FFF", height: 40 }}>
                                                                            <div title="Percentual gerado pela própria UC">
                                                                                {"G. Próp.: " + adicionarPontosMilhar(itemMes.total_percentual_geracao)}
                                                                            </div>
                                                                            <div title={itemMes.total_percentual_geracao_externa ? "Percentual recebido de usina alugada" : null}>
                                                                                {itemMes.total_percentual_geracao_externa
                                                                                    ? "G. Alug.: " + adicionarPontosMilhar(itemMes.total_percentual_geracao_externa)
                                                                                    : null}
                                                                            </div>
                                                                        </div>
                                                                        <div style={{ height: 40 }}>
                                                                            <div>
                                                                                {adicionarPontosMilhar(itemMes.total_saldo_geracao)}{" "}
                                                                                <ArrowOrEqualIcon iconName={getNomeIconeSaldo(itemMes.variacao_total_saldo_geracao)} />
                                                                            </div>
                                                                            {itemMes.total_saldo_geracao_ponta ? (
                                                                                <div>
                                                                                    {"P: " + adicionarPontosMilhar(itemMes.total_saldo_geracao_ponta)}
                                                                                    <ArrowOrEqualIcon iconName={getNomeIconeSaldo(itemMes.variacao_total_saldo_geracao_ponta)} />
                                                                                </div>
                                                                            ) : null}
                                                                            {itemMes.total_saldo_geracao_fora_ponta ? (
                                                                                <div>
                                                                                    {"FP: " + adicionarPontosMilhar(itemMes.total_saldo_geracao_fora_ponta)}{" "}
                                                                                    <ArrowOrEqualIcon
                                                                                        iconName={getNomeIconeSaldo(itemMes.variacao_total_saldo_geracao_fora_ponta)}
                                                                                    />
                                                                                </div>
                                                                            ) : null}
                                                                        </div>
                                                                    </Th>
                                                                );
                                                            })}
                                                        </Tr>
                                                    </TBody>
                                                </Table>
                                            );
                                        })
                                    ) : (
                                        <Table ref={tableRef} minHeight={"100%"} minWidth={window.innerWidth < 768 ? 1800 : 890}>
                                            <THead>
                                                <Tr>
                                                    <Th alignCenter minWidth={200} style={{ padding: 10, fontSize: fontSizePadrao }} stickyFirstColumn></Th>
                                                    {cabecalho.map((item, i, lista) => (
                                                        <Th
                                                            key={i}
                                                            colSpan="4"
                                                            alignCenter
                                                            style={{
                                                                fontSize: fontSizePadrao,
                                                                borderBottom: item.competencia == competenciaEmFoco ? `5px solid ${corDestaqueMesAtual}` : null,
                                                            }}
                                                        >
                                                            <IndicadorComSetas
                                                                desabilitarVoltar={i == 0}
                                                                desabilitarAvancar={i == lista.length - 1}
                                                                cor={corDestaqueMesAtual}
                                                                handleVoltar={() => {
                                                                    if (i == 0) return;
                                                                    const competenciaMesAnterior = lista[i - 1].competencia;
                                                                    setCompetenciaEmFoco(competenciaMesAnterior);
                                                                    tableRef.current.scrollHorizontal(-tamanhoColunaScroll);
                                                                }}
                                                                handleAvancar={() => {
                                                                    if (i == lista.length - 1) return;
                                                                    const competenciaProximoMes = lista[i + 1].competencia;
                                                                    setCompetenciaEmFoco(competenciaProximoMes);
                                                                    tableRef.current.scrollHorizontal(tamanhoColunaScroll);
                                                                }}
                                                                visivel={item.competencia == competenciaEmFoco}
                                                                titulo={item.competencia == competenciaUltimoMes ? "Último mês" : ""}
                                                            />
                                                        </Th>
                                                    ))}
                                                </Tr>
                                                <Tr>
                                                    <Th
                                                        backgroundColor="#2736cb"
                                                        rowSpan="2"
                                                        alignCenter
                                                        minWidth={200}
                                                        style={{ padding: 10, fontSize: fontSizePadrao }}
                                                        stickyFirstColumn
                                                    >
                                                        <div style={{ display: "flex", alignItems: "center", height: 70 }}>UCs</div>
                                                    </Th>
                                                    {cabecalho.map((item, i) => (
                                                        <Th
                                                            key={i}
                                                            backgroundColor={i % 2 == 0 ? "#5050fd" : "#3d3db8"}
                                                            colSpan="4"
                                                            alignCenter
                                                            style={{
                                                                fontSize: fontSizePadrao,
                                                                borderInline: item.competencia == competenciaEmFoco ? `5px solid ${corDestaqueMesAtual}` : null,
                                                            }}
                                                        >
                                                            {String(item.competencia).substring(4, 6) + "/" + String(item.competencia).substring(0, 4)}
                                                        </Th>
                                                    ))}
                                                </Tr>
                                                <Tr>
                                                    {cabecalho.map((item, i) => (
                                                        <>
                                                            <Th
                                                                key={i}
                                                                minWidth={120}
                                                                backgroundColor={i % 2 == 0 ? "#5050fd" : "#3d3db8"}
                                                                alignCenter
                                                                style={{
                                                                    fontSize: fontSizePadrao,
                                                                    borderLeft: item.competencia == competenciaEmFoco ? `5px solid ${corDestaqueMesAtual}` : null,
                                                                }}
                                                            >
                                                                kWh Recebidos
                                                            </Th>
                                                            <Th
                                                                minWidth={120}
                                                                backgroundColor={i % 2 == 0 ? "#5050fd" : "#3d3db8"}
                                                                alignCenter
                                                                style={{ fontSize: fontSizePadrao }}
                                                            >
                                                                R$ Recebidos
                                                            </Th>
                                                            <Th
                                                                minWidth={120}
                                                                backgroundColor={i % 2 == 0 ? "#5050fd" : "#3d3db8"}
                                                                alignCenter
                                                                style={{ fontSize: fontSizePadrao }}
                                                            >
                                                                Anexo G
                                                            </Th>
                                                            <Th
                                                                minWidth={120}
                                                                backgroundColor={i % 2 == 0 ? "#102a84" : "#0d2063"}
                                                                alignCenter
                                                                style={{
                                                                    fontSize: fontSizePadrao,
                                                                    borderRight: item.competencia == competenciaEmFoco ? `5px solid ${corDestaqueMesAtual}` : null,
                                                                }}
                                                            >
                                                                Saldo
                                                            </Th>
                                                        </>
                                                    ))}
                                                </Tr>
                                            </THead>
                                            <TBody>
                                                {listaEconomiaUsinaAluguelRemotasMensal.map((item) => {
                                                    return (
                                                        <Tr key={item.id_unidade_remota} style={{ borderBottom: "1px solid #FFF" }}>
                                                            <Td backgroundColor="#2736cb" color="#FFF" stickyFirstColumn fontSize={fontSizePadrao}>
                                                                {item.nome_unidade_consumidora}
                                                            </Td>
                                                            {item.meses.map((mes, i) => {
                                                                return (
                                                                    <React.Fragment key={i}>
                                                                        <Td
                                                                            minWidth={120}
                                                                            backgroundColor={i % 2 == 0 ? "#30303d" : "#272730"}
                                                                            color="#FFF"
                                                                            alignCenter
                                                                            fontSize={fontSizePadrao}
                                                                            borderLeft={mes.competencia == competenciaEmFoco ? `5px solid ${corDestaqueMesAtual}` : null}
                                                                        >
                                                                            {adicionarPontosMilhar(mes.quantidade_economia_fatura)}
                                                                        </Td>
                                                                        <Td
                                                                            minWidth={100}
                                                                            backgroundColor={i % 2 == 0 ? "#30303d" : "#272730"}
                                                                            color="#FFF"
                                                                            alignCenter
                                                                            fontSize={fontSizePadrao}
                                                                        >
                                                                            {adicionarPontosMilhar(mes.valor_economia_fatura)}
                                                                        </Td>
                                                                        <Td
                                                                            minWidth={160}
                                                                            backgroundColor={i % 2 == 0 ? "#30303d" : "#272730"}
                                                                            color="#FFF"
                                                                            alignCenter
                                                                            fontSize={fontSizePadrao}
                                                                        >
                                                                            <div title="Percentual gerado pela própria UC">
                                                                                {"G. Própria: " + adicionarPontosMilhar(mes.percentual_geracao)}
                                                                            </div>
                                                                            <div title={mes.percentual_geracao_externa ? "Percentual recebido de usina alugada" : null}>
                                                                                {mes.percentual_geracao_externa
                                                                                    ? "G. Alugada: " + adicionarPontosMilhar(mes.percentual_geracao_externa)
                                                                                    : null}
                                                                            </div>
                                                                        </Td>
                                                                        <Td
                                                                            minWidth={100}
                                                                            backgroundColor={i % 2 == 0 ? "#252631" : "#1f1f28"}
                                                                            color="#FFF"
                                                                            alignCenter
                                                                            fontSize={fontSizePadrao}
                                                                            borderRight={mes.competencia == competenciaEmFoco ? `5px solid ${corDestaqueMesAtual}` : null}
                                                                        >
                                                                            <div>
                                                                                {adicionarPontosMilhar(mes.saldo_geracao)}{" "}
                                                                                <ArrowOrEqualIcon iconName={getNomeIconeSaldo(mes.variacao_saldo_geracao)} />
                                                                            </div>
                                                                            {mes.saldo_geracao_ponta ? (
                                                                                <div>
                                                                                    {"P: " + adicionarPontosMilhar(mes.saldo_geracao_ponta)}{" "}
                                                                                    <ArrowOrEqualIcon iconName={getNomeIconeSaldo(mes.variacao_saldo_geracao_ponta)} />
                                                                                </div>
                                                                            ) : null}
                                                                            {mes.saldo_geracao_fora_ponta ? (
                                                                                <div>
                                                                                    {"FP: " + adicionarPontosMilhar(mes.saldo_geracao_fora_ponta)}{" "}
                                                                                    <ArrowOrEqualIcon iconName={getNomeIconeSaldo(mes.variacao_saldo_geracao_fora_ponta)} />
                                                                                </div>
                                                                            ) : null}
                                                                        </Td>
                                                                    </React.Fragment>
                                                                );
                                                            })}
                                                        </Tr>
                                                    );
                                                })}
                                                <Tr>
                                                    <Th backgroundColor="#1cc666" color="#FFF" style={{ padding: 10, fontSize: fontSizePadrao }} stickyFirstColumn>
                                                        <div style={{ display: "flex", alignItems: "center", height: 70, fontSize: fontSizePadrao }}>Total</div>
                                                    </Th>
                                                    {cabecalho.map((itemMes, i) => {
                                                        return (
                                                            <React.Fragment key={i}>
                                                                <Th
                                                                    minWidth={120}
                                                                    backgroundColor={i % 2 == 0 ? "#2ddc79" : "#1cc666"}
                                                                    color="#FFF"
                                                                    alignCenter
                                                                    style={{
                                                                        fontSize: fontSizePadrao,
                                                                        borderLeft: itemMes.competencia == competenciaEmFoco ? `5px solid ${corDestaqueMesAtual}` : null,
                                                                        borderBottom: itemMes.competencia == competenciaEmFoco ? `5px solid ${corDestaqueMesAtual}` : null,
                                                                    }}
                                                                >
                                                                    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: 70 }}>
                                                                        {adicionarPontosMilhar(itemMes.total_quantidade_economia_fatura)}
                                                                    </div>
                                                                </Th>
                                                                <Th
                                                                    minWidth={100}
                                                                    backgroundColor={i % 2 == 0 ? "#2ddc79" : "#1cc666"}
                                                                    color="#FFF"
                                                                    alignCenter
                                                                    style={{
                                                                        fontSize: fontSizePadrao,
                                                                        borderBottom: itemMes.competencia == competenciaEmFoco ? `5px solid ${corDestaqueMesAtual}` : null,
                                                                    }}
                                                                >
                                                                    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: 70 }}>
                                                                        {adicionarPontosMilhar(itemMes.total_valor_economia_fatura)}
                                                                    </div>
                                                                </Th>
                                                                <Th
                                                                    minWidth={100}
                                                                    backgroundColor={i % 2 == 0 ? "#2ddc79" : "#1cc666"}
                                                                    color="#FFF"
                                                                    alignCenter
                                                                    style={{
                                                                        fontSize: fontSizePadrao,
                                                                        borderBottom: itemMes.competencia == competenciaEmFoco ? `5px solid ${corDestaqueMesAtual}` : null,
                                                                    }}
                                                                >
                                                                    <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", height: 70 }}>
                                                                        <div>{"G. Própria: " + adicionarPontosMilhar(itemMes.total_percentual_geracao)}</div>
                                                                        <div>
                                                                            {itemMes.total_percentual_geracao_externa ? (
                                                                                "G. Alugada: " + adicionarPontosMilhar(itemMes.total_percentual_geracao_externa)
                                                                            ) : (
                                                                                <span>
                                                                                    {"G. Alugada: "} <span style={{ paddingInline: 10 }}>-</span>{" "}
                                                                                </span>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                </Th>
                                                                <Th
                                                                    minWidth={100}
                                                                    // backgroundColor={i % 2 == 0 ? "#2ddc79" : "#1cc666"}
                                                                    backgroundColor={"#02452f"}
                                                                    color="#FFF"
                                                                    alignCenter
                                                                    style={{
                                                                        fontSize: fontSizePadrao,
                                                                        borderRight: itemMes.competencia == competenciaEmFoco ? `5px solid ${corDestaqueMesAtual}` : null,
                                                                        borderBottom: itemMes.competencia == competenciaEmFoco ? `5px solid ${corDestaqueMesAtual}` : null,
                                                                    }}
                                                                >
                                                                    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: 70 }}>
                                                                        <div>
                                                                            {adicionarPontosMilhar(itemMes.total_saldo_geracao)}{" "}
                                                                            <ArrowOrEqualIcon iconName={getNomeIconeSaldo(itemMes.variacao_total_saldo_geracao)} />
                                                                        </div>
                                                                        {itemMes.total_saldo_geracao_ponta ? (
                                                                            <div>
                                                                                {"P: " + adicionarPontosMilhar(itemMes.total_saldo_geracao_ponta)}
                                                                                <ArrowOrEqualIcon iconName={getNomeIconeSaldo(itemMes.variacao_total_saldo_geracao_ponta)} />
                                                                            </div>
                                                                        ) : null}
                                                                        {itemMes.total_saldo_geracao_fora_ponta ? (
                                                                            <div>
                                                                                {"FP: " + adicionarPontosMilhar(itemMes.total_saldo_geracao_fora_ponta)}{" "}
                                                                                <ArrowOrEqualIcon iconName={getNomeIconeSaldo(itemMes.variacao_total_saldo_geracao_fora_ponta)} />
                                                                            </div>
                                                                        ) : null}
                                                                    </div>
                                                                </Th>
                                                            </React.Fragment>
                                                        );
                                                    })}
                                                </Tr>
                                            </TBody>
                                        </Table>
                                    ))}
                            </ContentCardBody>
                        </>
                    )}
                </ContentCardBody>
            </ContentCard>
        </div>
    );
}

function getNomeIconeSaldo(variacao) {
    switch (variacao) {
        case "AUMENTOU":
            return "arrowUpGreen";

        case "DIMINUIU":
            return "arrowDownRed";

        case "IGUAL":
            return "equalBlue";

        default:
            return null;
    }
}

const mapStateToProps = (state) => ({
    usuarioLogado: state.auth.usuarioLogado,
    filtro: state.analise.filtro,
    listaGraficoAluguelUsinaMensal: state.analise.listaGraficoAluguelUsinaMensal,
    listaEconomiaUsinaAluguelRemotasMensal: state.analise.listaEconomiaUsinaAluguelRemotasMensal,
});
const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getListaGraficoCustoMensalUsinaAluguel,
            getListaEconomiaUsinaAluguelRemotasMensal,
            gerarRelatorio,
        },
        dispatch
    );
const AnaliseContratoAluguel = connect(mapStateToProps, mapDispatchToProps)(analiseContratoAluguel);
export { AnaliseContratoAluguel };
